var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-slider"},[_c('ul',_vm._l((_vm.records),function(record){return _c('li',{key:record.id},[_vm._t("default",null,{"record":record})],2)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }